// extracted by mini-css-extract-plugin
module.exports = {"modalButtons":"TitleModal_modalButtons___ccpO","modalCreateButton":"TitleModal_modalCreateButton__ndPBQ","modalGoToButton":"TitleModal_modalGoToButton__ckH84"};